import { createFileRoute } from '@tanstack/react-router'

import { RetryAnalysisScreen } from './-components/retry-analysis-screen.tsx'
import { TSYS_RETRY_ANALYSIS } from './-lib/retry-analysis-variants.ts'

export const Route = createFileRoute('/payments/retry-analysis-tsys')({
  component: () => <RetryAnalysisScreen variant={TSYS_RETRY_ANALYSIS} />
})
